/**
 * # as-portal-target
 *
 * Receives content from matching `<as-portal>` elements.
 * Matched by the `name` attribute on the target and `target` attribute on the portal.
 *
 * ## Attributes
 * - `name`: Identifier that portals reference via their `target` attribute
 */
import { sendEv } from '../../data/events.ts';

export class AsPortalTarget extends HTMLElement {
  static readonly tag = 'as-portal-target' as const;

  static get observedAttributes() {
    return ['name'];
  }

  connectedCallback() {
    sendEv(window, 'as-portal-target-ready', {
      detail: { name: this.getAttribute('name'), element: this }
    });
  }
}

if (!customElements.get(AsPortalTarget.tag)) {
  customElements.define(AsPortalTarget.tag, AsPortalTarget);
}
